import { Box, Form, Grid, Select, Text, TextField } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { constants } from 'modules/common';
import { memo } from 'react';

import { messages } from './TaxPart.messages';
import { TaxPartProps } from './TaxPart.types';

const qa = 'tax';

export const TaxPart = memo<TaxPartProps>((props) => {
    const { taxCodes } = props;

    return (
        <div>
            <Form.Part>
                <Box spacing='16 0'>
                    <Text color='midnight80' font='headline' fontSize='xxsmall' fontWeight='medium'>
                        {messages.title}
                    </Text>
                </Box>

                <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                    <TextField
                        name='taxNumber'
                        label={messages.taxIdNumber}
                        placeholder={messages.taxIdNumberPlaceholder}
                        maxLength={constants.xeroConstants.TAX_NUMBER_MAX_LENGTH}
                        qa={domHelpers.generateDataQa(qa, 'tax-number-editor')}
                    />

                    <TextField
                        name='companyNumber'
                        label={messages.companyNumber}
                        placeholder={messages.companyNumberPlaceholder}
                        maxLength={constants.xeroConstants.COMPANY_NUMBER_MAX_LENGTH}
                        qa={domHelpers.generateDataQa(qa, 'company-number-editor')}
                    />

                    <Select
                        name='salesTax'
                        itemNameKey='text'
                        label={messages.salesTax}
                        placeholder={messages.salesTaxPlaceholder}
                        items={taxCodes}
                        autocomplete
                        qa={domHelpers.generateDataQa(qa, 'sales-tax-editor')}
                    />

                    <Select
                        name='purchaseTax'
                        itemNameKey='text'
                        label={messages.purchaseTax}
                        placeholder={messages.purchaseTaxPlaceholder}
                        items={taxCodes}
                        autocomplete
                        qa={domHelpers.generateDataQa(qa, 'purchase-tax-editor')}
                    />
                </Grid>
            </Form.Part>
        </div>
    );
});

TaxPart.displayName = 'TaxPart';
